<script>
  import { cart, stage, Stages, loadCart, deliveryServices, lockerPoint } from './storage.js';
  import Delivery from './Delivery.svelte';

  let { onlockermodal } = $props();

  let showModal = $state(false);

  let selectedDeliveryService = $derived(
    ($deliveryServices || []).find(s => s.id === $cart?.delivery_service_id)
  );

  const checkNextStep = () => {
    if (!$cart.no_delivery && !$cart.delivery_service_id) {
      showModal = true;
      return;
    }

    if (selectedDeliveryService?.type === 'DeliveryService::InpostLocker' && !$lockerPoint) {
      onlockermodal?.();
      return;
    }

    $stage = Stages.FORM;
  }

  const onDelivery = () => {
    showModal = false;
    loadCart();
  }
</script>


<div class="actions">
  {#if $cart && $cart.order_items.length}
    <button class="button" onclick={checkNextStep}>Przejdź do kasy</button>
  {/if}
</div>


{#if showModal}
  <Delivery
    onrefresh={onDelivery}
    onclose={() => showModal = false}
    openSelector={true}
  />
{/if}


<style>
  .actions {
    margin-bottom: 15px;
    display: flex;
    justify-content: flex-end;
  }
</style>
